import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const AccessProtectedRoute = ({
  children,
  feature,
  subFeature,
  featureProtected = false,
  allowedUserStatuses,
}) => {
  const { hasFeature, user } = useAuth();
  const location = useLocation();
  const userStatus = user?.data?.status;

  // Check user status restriction
  if (allowedUserStatuses && allowedUserStatuses.length > 0) {
    if (!userStatus || !allowedUserStatuses.includes(userStatus)) {
      return <Navigate to="/help" state={{ from: location }} replace />;
    }
  }

  // Check feature protection
  if (featureProtected) {
    if (feature) {
      if (!hasFeature(feature, subFeature)) {
        return <Navigate to="/help" state={{ from: location }} replace />;
      }
    } else {
      console.warn("Route marked as featureProtected but no feature specified");
    }
  }

  return children;
};

export default AccessProtectedRoute;
